import { FONT, RADIUS } from "@/styles/common";
import { Box, Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface CustomTagAvailableProps {
    isAvailableBook: boolean;
}

export const CustomTag = {
    Available: styled(Box)<CustomTagAvailableProps>`
        position: absolute;
        top: 0;
        left: 0;
        color: ${({ theme }) => theme.COLOR.white};
        background: ${({ isAvailableBook }) =>
            isAvailableBook ? ({ theme }) => theme.COLOR.positive[100] : ({ theme }) => theme.COLOR.text[500]};
        ${FONT("pretendard", 12, 500)}
    `,
    AmountOfImg: styled(Center)`
        position: absolute;
        right: 8px;
        bottom: 8px;
        color: ${({ theme }) => theme.COLOR.white};
        ${FONT("pretendard", 12, 700)}
        background: rgba(0, 0, 0, 0.7);
        ${RADIUS(10)}
        & span {
            font-size: 14px;
        }
    `,
};
